const createPortraitFormData = (payload, personalPhoto, FormDataConstructor) => {
    const formData = new FormDataConstructor();
    Object.keys(payload).forEach((field) => formData.append(field, payload[field]));
    formData.append("personalPhoto", personalPhoto);
    return formData;
};

const buildProfileUpdateSubmission = (payload, personalPhoto, FormDataConstructor) => {
    if (!personalPhoto) {
        return {
            payload,
            config: { headers: { "Content-Type": "application/json" } },
        };
    }
    return {
        payload: createPortraitFormData(payload, personalPhoto, FormDataConstructor),
        config: undefined,
    };
};

const buildRecoverySubmission = (payload, personalPhoto, FormDataConstructor) =>
    createPortraitFormData(payload, personalPhoto, FormDataConstructor);

module.exports = {
    buildProfileUpdateSubmission,
    buildRecoverySubmission,
};
